import OffCanvasMenuToggle from './components/OffCanvasMenuToggle'
import Navigation from './components/Navigation'
import HeaderHeight from './components/HeaderHeight'

const Header = () =>
    Promise.all([HeaderHeight(), Navigation(), OffCanvasMenuToggle()])

export default Header
